export default {
  isArray(value: any) {
    return Object.prototype.toString.call(value) === "[object Array]";
  },
  isObject(value: any) {
    return value !== null && typeof value === "object";
  },

  isString(value: any) {
    return typeof value === "string";
  },

  isNumber(value: any) {
    return typeof value === "number";
  },

  isInt(value: any) {
    return Number(value) === value && value % 1 === 0;
  },

  isFloat(value: any) {
    return value === Number(value) && !Number.isNaN(value);
  },

  isFunction(value: any) {
    return typeof value === "function";
  },

  isDate(value: any) {
    return toString.call(value) === "[object Date]";
  },

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  },

  isEmpty(value: any) {
    return value === null || value === undefined || value === "";
  },

  isEmptyObj(obj: object) {
    return Object.keys(obj).length === 0;
  },

  parseYYYYMMDD(yyyymmdd: string) {
    if (!yyyymmdd) {
      return yyyymmdd;
    }

    yyyymmdd = yyyymmdd.replace(/[\/,:, ,年,月,日]/g, "");

    if (yyyymmdd.length === 6) {
      return new Date(
        Number.parseInt(yyyymmdd.substr(0, 4), 10),
        Number.parseInt(yyyymmdd.substr(4, 2), 10) - 1,
        1,
      );
    }

    if (yyyymmdd.length === 7) {
      return new Date(
        Number.parseInt(yyyymmdd.substr(0, 4), 10),
        Number.parseInt(yyyymmdd.substr(4, 2), 10) - 1,
        1,
      );
    }

    if (yyyymmdd.length === 8) {
      return new Date(
        Number.parseInt(yyyymmdd.substr(0, 4), 10),
        Number.parseInt(yyyymmdd.substr(4, 2), 10) - 1,
        Number.parseInt(yyyymmdd.substr(6, 2), 10),
      );
    }

    if (yyyymmdd.length === 12) {
      return new Date(
        Number.parseInt(yyyymmdd.substr(0, 4), 10),
        Number.parseInt(yyyymmdd.substr(4, 2), 10) - 1,
        Number.parseInt(yyyymmdd.substr(6, 2), 10),
        Number.parseInt(yyyymmdd.substr(8, 2), 10),
        Number.parseInt(yyyymmdd.substr(10, 2), 10),
      );
    }

    return new Date(
      Number.parseInt(yyyymmdd.substr(0, 4), 10),
      Number.parseInt(yyyymmdd.substr(4, 2), 10) - 1,
      Number.parseInt(yyyymmdd.substr(6, 2), 10),
      Number.parseInt(yyyymmdd.substr(8, 2), 10),
      Number.parseInt(yyyymmdd.substr(10, 2), 10),
      Number.parseInt(yyyymmdd.substr(12, 2), 10),
    );
  },

  formatDate(date: Date, format: string) {
    function zeroFill(value: any) {
      value = String(value);
      return value.length === 1 ? "0" + value : value;
    }

    if (!date) {
      return "";
    }

    let result = "";
    const weeks = ["日", "月", "火", "水", "木", "金", "土"];
    let yen = false;
    let html = false;

    for (const char of format) {
      let c: any = char;
      if (!yen && !html) {
        switch (c) {
          case "\\":
            yen = true;
            continue;
          case "<":
            html = true;
            break;
          case "y":
            c = date.getFullYear();
            break;
          case "Y":
            c = String(date.getFullYear()).substr(2, 4);
            break;
          case "m":
            c = zeroFill(date.getMonth() + 1);
            break;
          case "M":
            c = date.getMonth() + 1;
            break;
          case "d":
            c = zeroFill(date.getDate());
            break;
          case "D":
            c = date.getDate();
            break;
          case "h":
            c = zeroFill(date.getHours());
            break;
          case "H":
            c = date.getHours();
            break;
          case "i":
            c = zeroFill(date.getMinutes());
            break;
          case "I":
            c = date.getMinutes();
            break;
          case "s":
            c = zeroFill(date.getSeconds());
            break;
          case "S":
            c = date.getSeconds();
            break;
          case "w":
            c = weeks[date.getDay()];
            break;
        }
      }

      result += c;
      yen = false;
      if (html && c === ">") {
        html = false;
      }
    }

    if (yen) {
      result += "\\";
    }

    return result;
  },

  isEmail(value: string) {
    const pattern =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value);
  },

  numberTwoDigitsStr(num: number) {
    return num.toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });
  },

  romanize(num: number) {
    const lookup: { [key: string]: number } = {
      M: 1000,
      CM: 900,
      D: 500,
      CD: 400,
      C: 100,
      XC: 90,
      L: 50,
      XL: 40,
      X: 10,
      IX: 9,
      V: 5,
      IV: 4,
      I: 1,
    };
    let roman = "";
    for (const field of Object.keys(lookup)) {
      while (num >= lookup[field]) {
        roman += field;
        num -= lookup[field];
      }
    }
    return roman;
  },
};
